(function () {
  'use strict';

  // Theme toggle
  var THEME_KEY = 'dv-theme';
  function applyTheme(t) {
    if (t === 'dark') document.documentElement.classList.add('dark');
    else document.documentElement.classList.remove('dark');
  }
  document.querySelectorAll('[data-theme-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var isDark = document.documentElement.classList.contains('dark');
      var next = isDark ? 'light' : 'dark';
      try { localStorage.setItem(THEME_KEY, next); } catch (e) {}
      applyTheme(next);
    });
  });

  // Mobile menu
  document.querySelectorAll('[data-menu-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var menu = document.querySelector('[data-mobile-menu]');
      if (!menu) return;
      var open = !menu.hasAttribute('hidden');
      if (open) {
        menu.setAttribute('hidden', '');
        btn.setAttribute('aria-expanded', 'false');
      } else {
        menu.removeAttribute('hidden');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });

  // Tabs
  document.querySelectorAll('[data-tabs]').forEach(function (root) {
    var triggers = root.querySelectorAll('[data-tab-trigger]');
    var panels = root.querySelectorAll('[data-tab-panel]');
    triggers.forEach(function (t) {
      t.addEventListener('click', function () {
        var name = t.getAttribute('data-tab-trigger');
        triggers.forEach(function (x) { x.classList.toggle('is-active', x === t); });
        panels.forEach(function (p) {
          if (p.getAttribute('data-tab-panel') === name) p.removeAttribute('hidden');
          else p.setAttribute('hidden', '');
        });
      });
    });
  });

  // Quantity steppers
  document.querySelectorAll('[data-qty-stepper]').forEach(function (root) {
    var input = root.querySelector('input');
    var dec = root.querySelector('[data-qty-dec]');
    var inc = root.querySelector('[data-qty-inc]');
    if (!input) return;
    function commit(val) {
      var n = Math.max(0, parseInt(val, 10) || 0);
      input.value = n;
      if (root.dataset.autosubmit && root.closest('form')) {
        root.closest('form').submit();
      }
    }
    if (dec) dec.addEventListener('click', function () { commit((parseInt(input.value, 10) || 0) - 1); });
    if (inc) inc.addEventListener('click', function () { commit((parseInt(input.value, 10) || 0) + 1); });
  });

  // View mode toggle (collection)
  document.querySelectorAll('[data-view-toggle]').forEach(function (root) {
    var grid = document.querySelector('[data-product-grid]');
    if (!grid) return;
    root.querySelectorAll('button').forEach(function (b) {
      b.addEventListener('click', function () {
        root.querySelectorAll('button').forEach(function (x) { x.classList.toggle('is-active', x === b); });
        var mode = b.getAttribute('data-view-mode');
        grid.classList.toggle('product-grid--list', mode === 'list');
        grid.classList.toggle('product-grid--cols-4', mode !== 'list');
      });
    });
  });

  // Cookie consent
  var COOKIE_KEY = 'dv-cookie-consent';
  var banner = document.querySelector('[data-cookie-banner]');
  if (banner) {
    var stored;
    try { stored = localStorage.getItem(COOKIE_KEY); } catch (e) {}
    if (stored !== 'accepted' && stored !== 'rejected') {
      banner.removeAttribute('hidden');
    }
    banner.querySelectorAll('[data-cookie-action]').forEach(function (b) {
      b.addEventListener('click', function () {
        try { localStorage.setItem(COOKIE_KEY, b.getAttribute('data-cookie-action')); } catch (e) {}
        banner.setAttribute('hidden', '');
      });
    });
  }
  document.querySelectorAll('[data-cookies-page-action]').forEach(function (b) {
    b.addEventListener('click', function () {
      var v = b.getAttribute('data-cookies-page-action');
      try { localStorage.setItem(COOKIE_KEY, v); } catch (e) {}
      var note = document.querySelector('[data-cookies-current]');
      if (note) {
        note.textContent = 'Current preference: ' + v;
        note.removeAttribute('hidden');
      }
    });
  });

  // Live cart count refresh
  function refreshCart() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (n) {
          n.setAttribute('data-cart-count', cart.item_count);
          n.textContent = cart.item_count;
        });
      })
      .catch(function () {});
  }
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (form.matches && form.matches('form[action$="/cart/add"], form[action="' + (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add"]')) {
      // Let Shopify handle the request, then refresh count after a moment
      setTimeout(refreshCart, 600);
    }
  }, true);
})();
